import { render } from "./CourseGroupForm.vue?vue&type=template&id=624f84ba&scoped=true"
import script from "./CourseGroupForm.vue?vue&type=script&lang=js"
export * from "./CourseGroupForm.vue?vue&type=script&lang=js"

import "./CourseGroupForm.vue?vue&type=style&index=0&id=624f84ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624f84ba"]])

export default __exports__